export const CartActionTypes = {
  REMOVE: 'REMOVE',
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
  CLEAR_CART: 'CLEAR_CART',
  ADD_TO_CART: 'ADD_TO_CART'
}